// Shuffles (randomizes) order of elements in an array
// Note: this runs in O(N log N) but consider using something else
// for large arrays. More on this here: https://stackoverflow.com/a/46545530
export const shuffleArray = (arrayToShuffle: any[]) => {
  return arrayToShuffle
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
};
